export default (report) => {
  return report.version && process.env.VERSION === report.version
}
